






































import { Prop, Component, Vue } from 'vue-property-decorator'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

@Component
export default class PerformResetPassword extends Vue {
    @Prop({ required: true }) readonly request!: string
    password: string = ''
    validation: string = ''
    loading: boolean = false

    async performResetPassword(): Promise<void> {
        try {
            this.loading = true
            await axios.post(`${baseUrl}/do_password_reset`, {
                request: this.request,
                password: this.password,
                origin: 'keyvue',
            })
            await this.$router.push({
                name: 'user_perform_reset_password_success',
            })

        } catch (error) {
            this.$notify({
                group: 'information',
                type: 'error',
                text: 'Deze aanvraag is reeds eerder al gebruikt',
            })

        } finally {
            this.loading = false
        }
    }
}
